import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';


function getConfigForElement(element) {
  return {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    navigation: {
      nextEl: element.querySelector('.swiper-next'),
      prevEl: element.querySelector('.swiper-prev'),
    },
    breakpoints: {
      768: { slidesPerView: 1.5, spaceBetween: 50 },
      1024: { slidesPerView: 2.5, spaceBetween: 100 },
    },
  };
}

class SwiperContainer {
  constructor(element) {
    this.element = element;
    this.instance = new Swiper(element, getConfigForElement(element));
  }

  destroy() {
    if (this.instance && typeof this.instance.destroy === 'function') {
      this.instance.destroy(true, true);
      this.instance = null;
    }
  }
}

export function initSwiperContainer() {
  const instances = [];

  const regularElements = Array.from(document.querySelectorAll('.swiper')).filter(
    (el) => !el.classList.contains('swiper--gallery')
  );
  instances.push(...regularElements.map((el) => new SwiperContainer(el)));

  const galleryElements = document.querySelectorAll('.swiper--gallery');
  if (galleryElements.length) {
    galleryElements.forEach((el) => {
      const swiper = new Swiper(el, {
        modules: [Navigation, Pagination],
        slidesPerView: "auto",
        spaceBetween: 16,
        navigation: {
          nextEl: el.querySelector('.swiper-next'),
          prevEl: el.querySelector('.swiper-prev'),
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });

      instances.push({ destroy: () => swiper.destroy(true, true) });
    });
  }

  if (!instances.length) return null;

  return () => instances.forEach((instance) => instance.destroy());
}
